import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { Link, TextAccent } from '../../components';
import { Wrapper, Header, BlogItemHeading, ImageWrapper } from './BlogItem.style';

const defineMetaColorKind = colorKind =>
  colorKind === 'dark' ? 'darkTransparent' : colorKind === 'light' ? 'lightTransparent' : 'neutral';

/**
 * BlogListing: BlogItem component
 */
const BlogItem = ({ frontmatter, slug }) => {
  const { title, inlineSubtitle, excerpt, tags, date, blogThemeConfig, postKind, image } = frontmatter;
  const metaColorKind = defineMetaColorKind(blogThemeConfig.color);

  return (
    <Wrapper blogThemeConfig={blogThemeConfig}>
      <TextAccent element="time" colorKind={metaColorKind} size="default">
        {date}
      </TextAccent>
      <Header postKind={postKind}>
        {postKind === 'quote' ? (
          <BlogItemHeading element="h2" size="h1">
            <Link to={`/blog${slug}`} colorKind={blogThemeConfig.color} linkKind="no-underline">
              {excerpt}
            </Link>
          </BlogItemHeading>
        ) : (
          <>
            <BlogItemHeading element="h2" size="h3" postKind={postKind}>
              <Link to={`/blog${slug}`} colorKind={blogThemeConfig.color} linkKind="no-underline">
                {title} {inlineSubtitle && <span style={{ fontWeight: 400 }}>{inlineSubtitle}</span>}
              </Link>
            </BlogItemHeading>
            <TextAccent element="p" colorKind={blogThemeConfig.color}>
              {excerpt}
            </TextAccent>
          </>
        )}
      </Header>
      {image && (
        <Link to={`/blog${slug}`}>
          <ImageWrapper>
            <Img fluid={image.childImageSharp.fluid} imgStyle={{ objectFit: 'contain' }} alt={title} />
          </ImageWrapper>
        </Link>
      )}
      <footer>
        {tags.map((item, index, array) => (
          <TextAccent element="span" size="default" colorKind={metaColorKind} key={item}>
            #{item}
            {index === array.length - 1 ? '' : ','}&nbsp;
          </TextAccent>
        ))}
      </footer>
    </Wrapper>
  );
};

BlogItem.propTypes = {
  frontmatter: PropTypes.shape({
    title: PropTypes.string,
    inlineSubtitle: PropTypes.string,
    date: PropTypes.string,
    excerpt: PropTypes.string,
    postKind: PropTypes.oneOf(['default', 'quote']),
    blogThemeConfig: PropTypes.shape({
      color: PropTypes.string,
      background: PropTypes.string,
    }),
    image: PropTypes.any,
    tags: PropTypes.array,
    metaDescription: PropTypes.string,
  }).isRequired,
  slug: PropTypes.string.isRequired,
};

export default BlogItem;
